import { createApiAction } from '@app/packages/api/utils'
import type { ApiPlaygroundEventType, ApiPlaygroundRequest } from '@app/packages/api/v2/types/entities'
import type { PostPlaygroundRequestsRequest } from '@app/packages/api/v2/types/params'

export const getPlaygroundRequestsEventTypes = () =>
  createApiAction('getPlaygroundRequestsEventTypes', dispatch =>
    dispatch<{ data: ApiPlaygroundEventType[] }>({ method: 'GET', endpoint: '/api/v2/playground_requests/event_types' })
  )

export const postPlaygroundRequests = (request: PostPlaygroundRequestsRequest) =>
  createApiAction('postPlaygroundRequests', dispatch =>
    dispatch<{ data: ApiPlaygroundRequest }>({ method: 'POST', endpoint: '/api/v2/playground_requests', body: JSON.stringify(request) })
  )
